import Base from "@/controllers/base";
export default class DriverDoc extends Base {
  constructor(elem) {
    super(elem);
  }

  nextJ1s(event) {
    const link = event.target.closest("a");
    const selector = `#docs li[data-id="${link.dataset.id}"]`;
    const section = document.querySelector(selector).nextElementSibling;
    if (section) this.reviewJ1sDoc(section.dataset.id);
  }

  prevJ1s(event) {
    const link = event.target.closest("a");
    const selector = `#docs li[data-id="${link.dataset.id}"]`;
    const section = document.querySelector(selector).previousElementSibling;
    if (section) this.reviewJ1sDoc(section.dataset.id);
  }

  async reviewJ1sDoc(id) {
    try {
      const response = await fetch(
        `/docs/${id}/review?` +
          new URLSearchParams({ nav: "doc", layout: "empty" }),
        { method: "GET" }
      );
      document.querySelector(".html .doc").innerHTML = await response.text();
      NApp.dispatchTurboLoad();
    } catch (ex) {}
  }

  dayLogByDate(event) {
    const link = event.target.closest("a");
    this.reviewDayLog(link.dataset.id, link.dataset.date);
  }

  async reviewDayLog(id, date) {
    try {
      const response = await fetch(
        `/docs/0/review?` +
          new URLSearchParams({
            trucker_id: id,
            date: date,
            nav: "day_log",
            layout: "empty",
          }),
        { method: "GET" }
      );
      document.querySelector(".html .day-log").innerHTML =
        await response.text();
      NApp.dispatchTurboLoad();
    } catch (ex) {}
  }

  choosePendingDoc(event) {
    const item = event.target.closest("li");
    item.classList.toggle("active");
  }

  async assignTarget(event) {
    try {
      const link = event.target;
      const ids = [...document.querySelectorAll("#pending-docs li.active")].map(
        (li) => li.dataset.id
      );
      if (ids.length == 0) {
        alert("Please choose at least one doc then assign.");
      } else {
        if (confirm("Are you sure to move the selected docs?")) {
          const response = await fetch("/docs/assign.json", {
            method: "PUT",
            headers: this.defaultHeaders,
            body: JSON.stringify({
              image: {
                imagable_type: link.dataset.imagableType,
                imagable_id: link.dataset.imagableId,
                column_name: link.dataset.columnName,
              },
              ids: ids,
            }),
          });
          const result = await response.json();
          result.forEach((image) => {
            const uuid = image.uuid;
            const list = document.querySelector("#pending-docs");
            let elem = list.querySelector(`li[data-id="${uuid}"]`);
            if (elem) {
              elem.classList.remove(...elem.classList);
              elem.classList.add("approved");
            }
            elem = document.querySelector(`li[data-status-id="${uuid}"]`);
            if (elem) {
              elem.classList.remove(...elem.classList);
              elem.classList.add("num", "approved");
            }
          });
        }
      }
    } catch (ex) {}
  }
}
